import type { ReactNode } from 'react';

export const symbol_fire_check: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m662-165 154-154q9-9 21-9t21 9q9 9 9 21.5t-9 21.5L683-101q-9 9-21 9t-21-9l-88-88q-9-9-9-21t9-21q9-9 21.5-9t21.5 9l66 66ZM480-449Zm-320 9q0-119 74.5-230.5T439-858q14-8 27.5 0t13.5 24v86q0 34 23.5 57t57.5 23q18 0 33.5-7.5T622-698l4-5q6-8 15.5-9t17.5 4q60 41 97 103.5T799-468q2 14-7 21.5t-20 8.5q-11 1-21.5-6T738-468q-3-23-9.5-46T711-558.5q-11-21.5-26-42T651-640q-21 15-44 23.5t-46 8.5q-61 0-101-41.5T420-754v-20q-92 66-146 156.5T220-440q0 108 75 183t182 77q11 14 8.5 31.5T469-120q-14 11-31.5 8.5T409-128q-57-13-106-45t-84-81q-28-39-43.5-86.5T160-440Z"
		/>
	</svg>
);
